import React from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  List,
  ListIcon,
  ListItem,
  Flex,
  Text,
} from "@chakra-ui/react";
import { Link } from "@reach/router";
import { MdInfo, MdPeople, MdContactMail } from "react-icons/md";
import { RiDatabase2Line } from "react-icons/ri";
import { basepath } from "../constants/basepath";


const links = [
  {
    id: "about",
    icon: MdInfo,
    title: "About",
    to: `${basepath}/about`,
  },
  {
    id: "contribute",
    icon: RiDatabase2Line,
    title: "Contribute Data",
    to: `${basepath}/contribute`,
  },
  {
    id: "acknowledgment",
    icon: MdPeople,
    title: "Acknowledgment",
    to: `${basepath}/acknowledgment`,
  },
  {
    id: "contacts",
    icon: MdContactMail,
    title: "Contacts",
    to: `${basepath}/contacts`,
  },
];

// TODO: make the help tooltip point to `search` instead of `menu`
// TODO: fix error in https://insideidaho.org/sharing/rest?f=json

const SidebarMenu = ({ isOpen, onClose, title }) => {
  return (
    <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
      <DrawerContent zIndex={60}>
        <DrawerCloseButton />
        <DrawerHeader
          borderBottomWidth="1px"
          textTransform="uppercase"
          fontSize="sm"
        >
          {title}
        </DrawerHeader>
        <DrawerBody>
          <List spacing={3}>
            {links.map((link) => (
              <ListItem key={link.id}>
                <Link to={link.to}>
                  <Flex alignItems="center">
                    <ListIcon as={link.icon} boxSize={6} />
                    <Text>{link.title}</Text>
                  </Flex>
                </Link>
              </ListItem>
            ))}
          </List>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default SidebarMenu;
